// Import dependencies
import React, { useState, useEffect } from "react";
import { Container, AppBar, Typography, Grow, Grid } from "@material-ui/core";
import { useDispatch } from "react-redux";
import dotenv from "dotenv";
import Posts from "./components/Posts/Posts";
import Form from "./components/Form/Form";
import useStyles from "./styles";
import { getPosts } from "./actions/posts";
import xmeme from "./images/xmeme.jpg";

dotenv.config();

const App = () => {
  // currentId stores the id of the meme and setCurrentId updates it
  const [currentId, setCurrentId] = useState(0);

  const dispatch = useDispatch();

  // css styling
  const classes = useStyles();

  // Load changes effectively
  useEffect(() => {
    dispatch(getPosts());
  }, [currentId, dispatch]);

  return (
    <Container maxWidth="lg">
      <AppBar className={classes.appBar} position="static" color="inherit">
        <Typography className={classes.heading} variant="h3" align="center">
          XMeme
        </Typography>
        <img className={classes.image} src={xmeme} alt="icon" height="60" />
        <Typography variant="body2" align="right">
          {" "}
          &nbsp; ~ Rishabh Raizada
        </Typography>
      </AppBar>
      <Grow in>
        <Container>
          <Grid
            className={classes.mainContainer}
            container
            justify="space-between"
            alignItems="stretch"
            spacing={3}
          >
            <Grid item xs={12} sm={7}>
              <Posts setCurrentId={setCurrentId} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Form currentId={currentId} setCurrentId={setCurrentId} />
            </Grid>
          </Grid>
        </Container>
      </Grow>
    </Container>
  );
};

export default App;
